/**
 * Form delivery for the BEAT site.
 *
 * Signups and enquiries are posted to Web3Forms, which forwards them as email.
 * General brand enquiries go to info@, everything order related goes to order@.
 */
const WEB3FORMS_KEY = 'a23b9419-6869-4092-bd1e-0a48a2461c5e'

export const CONTACT_EMAIL = 'info@beatsoda.com'
export const ORDER_EMAIL = 'order@beatsoda.com'

export async function sendToBeat(
  payload: Record<string, string>,
  to: string = CONTACT_EMAIL,
): Promise<boolean> {
  try {
    const response = await fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        access_key: WEB3FORMS_KEY,
        from_name: 'BEAT Website',
        to,
        ...payload,
      }),
    })
    return response.ok
  } catch {
    return false
  }
}
